export const clientId="1267862520744640674";
export const apiDomain=`${clientId}.discordsays.com/.proxy/api`;
const surfDomain=`${clientId}.discordsays.com/.proxy/surf`;

export function getSurfWsUrl(roomId:string,code:string){
    return `wss://${surfDomain}/bp-${roomId}?code=${code}`;
}